import { faMousePointer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { getAdmissionDate } from "../Components/CourseRegistration/admissionDates.js";
import AcademicCalendar from "./HomeComponents/AcademicCalender";

export const filterCoursesWithDates = () => {
  let courses = getAdmissionDate();

  // Sort based on closest upcoming date
  return courses
    .filter((course) => {
      const date = new Date(course.admissionStartDate);
      return !isNaN(date); // Keep only entries with valid dates
    })
    .sort((a, b) => {
      const dateA = new Date(a.admissionEndDate);
      const dateB = new Date(b.admissionEndDate);
      return dateA - dateB; // Sort in ascending order (closest date first)
    });
};

const Registration = () => {
  const colortheme = [
    "bg-orange-400", // Emergency
    "bg-orange-300",
    "bg-yellow-200",
    "bg-yellow-200",
    "bg-yellow-200",
    "bg-yellow-200",
    "bg-green-200",
    "bg-green-300",
    "bg-green-400", // No urgency
  ];

  return (
    <div className="container mx-auto px-5 my-10">
      <section className="my-10">
        <p className="text-center text-2xl">এই কোর্সগুলোতে ভর্তি হতে পারেন!</p>
      </section>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 registration_info_card">
        {filterCoursesWithDates().map((course, i) => (
          <Link key={i} to={`/registration-${course.course}`}>
            <div className={`p-3 rounded ${colortheme[i]}`}>
              <span className="underline">{course.name}</span>

              <span>
                {new Date() > new Date(course.admissionStartDate) ? (
                  <span>
                    {" "}
                    <FontAwesomeIcon
                      className="mx-3 text-slate-500"
                      icon={faMousePointer}
                      fade
                    />{" "}
                    ভর্তি চলছে
                  </span>
                ) : (
                  ""
                )}
              </span>
              <p>
                {new Date() > new Date(course.admissionStartDate)
                  ? `ভর্তি শেষ হবে ${course.admissionEndDate}`
                  : `ভর্তি শুরু হবে ${course.admissionStartDate}`}
              </p>
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-20">
        <AcademicCalendar />
      </div>
    </div>
  );
};

export default Registration;
